import axios from 'axios';

interface LinkProps {
  shortLink: string;
}
export const getFibesabeLink = async (link: string) => {
  const config = {
    domainUriPrefix: 'https://openenglish.page.link',
    key: 'AIzaSyCzR7Vz2SQ1hoOzDR1pMG5OFtn98nJCcQE',
  };
  try {
    const { data } = await axios.post<LinkProps>(
      `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${config.key}`,
      {
        dynamicLinkInfo: {
          domainUriPrefix: config.domainUriPrefix,
          link,
        },
        suffix: {
          option: 'SHORT',
        },
      }
    );

    // const { shortLink } = data;
    return data.shortLink || link;
  } catch (error) {
    return link;
  }
};
